import {articles} from './shared.js';
import {jumpToChapter} from './nav.js';
import {enable as enableTicker} from './ticker.js';

const intro = document.querySelector('#intro');
const arabic = intro.querySelector('li:nth-of-type(1)');
const english = intro.querySelector('li:nth-of-type(2)');
const disclaimer = intro.querySelector('li:nth-of-type(3)');
const narrative = intro.querySelector('li:nth-of-type(4)');
const narrativeContent = Array.from(narrative.querySelectorAll('time, p'));
const cta = intro.querySelector('li:nth-of-type(5)');
export const buttonUp = cta.querySelector('button:nth-of-type(1)');
export const buttonDown = cta.querySelector('button:nth-of-type(2)');
const skip = document.querySelector('#intro-skip');
const progress = intro.querySelector('#progress');
const progressFill = progress.querySelector('span');
const timeline = new TimelineLite({paused: true});

let loadingTween = TweenLite.to({}, 0.25, {});

/**
 * Assets loaded
 * @param {Number} percent percent
 */
export function assetPreloaded(percent) {
  loadingTween.kill();
  loadingTween = TweenLite.to(progressFill, 0.250, {x: `${-100 + 100 * percent}%`});
  if (percent >= 1) {
    progress.classList.add('hide');
  }
}

/**
 * Start the intro animation
 * @param {Promise} setupPromise resolves when assets have loaded and app setup is complete
 */
export function startIntro(setupPromise) {
  console.log('intro:startIntro');

  setupPromise.then(() => {
    skip.innerHTML = 'SKIP INTRO';
    skip.classList.add('interactive');
    cta.classList.add('interactive');
  });

  const animPromise = new Promise(resolve => {
    timeline.eventCallback('onComplete', () => resolve());
    skip.addEventListener('click', evt => {
      console.log('skip');
      event.stopPropagation();
      timeline.progress(1, false);
      resolve();
    });
  });

  animPromise.then(() => {
    console.log('intro animation complete');
  });

  const introPromise = Promise.all([setupPromise, animPromise]);

  introPromise.then(() => console.log('setup complete and intro animation complete'));

  timeline.play();
}

/**
 * Call when intro completes to set up the transition from the intro to the content
 * @param {DOMNode} article article to jump to
 */
function completeIntro(article) {
  console.log('intro:completeIntro');

  document.body.classList.add('intro-done');

  setTimeout(() => {
    jumpToChapter(article, 10).then(() => {
      console.log('enabling ticker');
      enableTicker();
      intro.classList.add('dismiss');
      intro.addEventListener('transitionend', () => intro.classList.add('hide'), {once: true});
    });
  }, 0);
}

// trap clicks on intro
intro.addEventListener('click', evt => evt.stopPropagation());

for (const button of [buttonUp, buttonDown]) {
  button.addEventListener('click', event => {
    event.stopPropagation();
    completeIntro(articles.find(article => article.dataset.chapter === button.dataset.chapter));
  });
}

TweenLite.set([arabic, english, disclaimer, narrative, narrativeContent, cta], {opacity: 0});

timeline.set(intro, {css: {className: '+=loaded'}});

timeline.to(arabic, 1, {opacity: 1}, '+=1');

timeline.to(arabic, 1, {opacity: 0}, '+=1');

timeline.to(english, 1, {opacity: 1}, '+=0.5');

timeline.to(english, 1, {opacity: 0}, '+=2');

timeline.to(disclaimer, 1, {opacity: 1}, '+=0.5');

timeline.to(disclaimer, 1, {opacity: 0}, '+=3');

timeline.set(skip, {css: {className: '+=hide'}});

timeline.to(narrative, 2, {opacity: 1});

timeline.set(intro, {css: {className: '+=dark'}});

timeline.to(narrativeContent, 1, {opacity: 1});

timeline.to(narrative, 1, {opacity: 0}, '+=3');

timeline.to(cta, 1, {opacity: 1});
